import sortBy from 'lodash.sortby';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import constants from '../../../../constants';

const ViewDataModal = ({ isOpen = false, data = [], onClose }) => {
	const modalRef = useRef();
	useEffect(() => {
		if (isOpen) {
			modalRef.current.showModal();
		} else {
			modalRef.current.close();
		}
	}, [isOpen]);
	return (
		<dialog
			id="view-dashboard-data-dialog"
			className="modal modal-top"
			ref={modalRef}
		>
			<div className="modal-box">
				<h3>Dashboard Data</h3>
				<table className="table table-zebra table-sm">
					<thead>
						<tr>
							<th>Created Date</th>
							<th>Referring Agency</th>
							<th>Service</th>
							<th>Receiving Agency</th>
							<th>Status</th>
							<th>SKU</th>
							<th>Completed Data</th>
						</tr>
					</thead>
					<tbody>
						{sortBy(data, ['ref_agency_name', 'created_on']).map((row) => (
							<tr key={`${row.request_id}`}>
								<td>{new Date(row.created_on).toLocaleDateString()}</td>
								<td>{row.ref_agency_name}</td>
								<td>{row.service_category}</td>
								<td>{row.rec_agency_name}</td>
								<td>{constants.status[row.request_status]}</td>
								<td>{row.sku_label}</td>
								<td>
									{row.completed_on
										? new Date(row.completed_on).toLocaleDateString()
										: 'N/A'}
								</td>
							</tr>
						))}
					</tbody>
				</table>
				<div className="modal-action">
					<form method="dialog" onSubmit={onClose}>
						<button className="btn btn-primary">Close</button>
					</form>
				</div>
			</div>
		</dialog>
	);
};

ViewDataModal.propTypes = {
	isOpen: PropTypes.bool,
	data: PropTypes.array,
	onClose: PropTypes.func.isRequired,
};

export default ViewDataModal;
